import type { UnresolvedMenuItem, UnresolvedMenuItems } from '@wix/public-resolvers'
import type { Link } from '@wix/public-schemas'
import type { DataMap, MenuItemProps, ResolvedBasicMenuItem, ResolvedSubMenuItem } from '@wix/thunderbolt-becky-types'
import { removeHash } from '@wix/thunderbolt-commons'

export const resolveMenuItemsRecursively = (
	item: ResolvedBasicMenuItem | ResolvedSubMenuItem,
	isMobileView: boolean,
	withId: boolean
): MenuItemProps => {
	const { id: itemId, label, items: subItems, link: itemLink, displayCount } = item
	// @ts-expect-error remove after adding this type to editor-elements-definition lib
	const { shouldSupportLegacySubmenuDesign } = item
	const id = withId ? { id: itemId } : {}
	// @ts-ignore
	const link = (itemLink ?? {}) as Carmi<LinkProps>
	const slot = isResolvedBasicMenuItem(item) ? { slot: item.slot } : {}

	const items = subItems
		? subItems
			.filter((subItem) => shouldShowItem(subItem, isMobileView))
			.map((subItem) => resolveMenuItemsRecursively(subItem, isMobileView, withId))
		: []

	const filteredItems = items.length > 0 ? { items } : {}

	return {
		label,
		link,
		// @ts-ignore TODO: remove after adding this type to editor-elements-definition lib
		...(displayCount ? { displayCount } : {}),
		...filteredItems,
		...slot,
		...id,
		...(shouldSupportLegacySubmenuDesign ? { shouldSupportLegacySubmenuDesign } : {}),
	}
}

const isResolvedBasicMenuItem = (item: ResolvedBasicMenuItem | ResolvedSubMenuItem): item is ResolvedBasicMenuItem =>
	'slot' in item

const shouldShowItem = (item: ResolvedBasicMenuItem | ResolvedSubMenuItem, isMobileView: boolean) => {
	return isMobileView ? item.isVisibleMobile : item.isVisible
}

type UnresolvedMenuItemWithRefs = Omit<UnresolvedMenuItem, 'items' | 'link'> & {
	link?: string
	items?: Array<string>
}

export const resolveMenuItemsRefs = (itemIds: Array<string>, data: DataMap, resolvedLinks: DataMap): Array<UnresolvedMenuItem> => {
	return itemIds.map((itemId) => {
		const itemData = data[removeHash(itemId)] as unknown as UnresolvedMenuItemWithRefs
		const linkId = itemData.link || ''
		const resolvedLink = resolvedLinks[removeHash(linkId)] as unknown as Link
		const items = itemData.items || []
		const resolvedItems = resolveMenuItemsRefs(items, data, resolvedLinks)
		return {
			...itemData,
			link: resolvedLink,
			items: resolvedItems,
		}
	}) as Array<UnresolvedMenuItem>
}
